import React from "react";
import TitleH1 from "../Titles/title-h1";
import SearchBookForm from "./SearchBookForm";
import RenderBook from "../books/RenderBook";
import PropTypes from 'prop-types';
import CreateBookButton from "../books/CreateBook/CreateBookButton";


const SearchBookPage = ({ books, handleSearch, title, setTitle, author, setAuthor }) => {
    return (
        <>
            <TitleH1>Search Book</TitleH1>
            <SearchBookForm
                handleSearch={handleSearch}
                title={title} setTitle={setTitle}
                author={author} setAuthor={setAuthor}
            />
            {books.length > 0 && <RenderBook books={books} />}
            <CreateBookButton/>
        </>
    );
};

SearchBookPage.propTypes = {
    books: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        volumeInfo: PropTypes.shape({
            title: PropTypes.string.isRequired,
            authors: PropTypes.arrayOf(PropTypes.string),
            language: PropTypes.string
        })
    })).isRequired,
    handleSearch: PropTypes.func.isRequired
};

export default SearchBookPage;